<template>
  <v-container fluid class="h-10">
    <v-row>
      <v-col class="py-0" cols="10" offset="1">
        <v-row>
          <v-col cols="12 text-center" v-if="loading">
            <h2 class="title white--text font-weight-light">
              Loading
            </h2>
          </v-col>
          <v-col class="py-0 12">
            <h1 v-if="false" style="font-weight: 900; text-align: left;font-size: 40px;
          color:#3200e6; font-family: 'Arial','Segoe UI',
          'Segoe',Tahoma,Helvetica,Arial,sans-serif;">GDPR</h1>
          <v-form  ref="GDPRForm" v-model="valid" lazy-validation>
            <p>You can exercise your rights or make a claim on
               your personal data via the form below.
            </p>
            <p>Any request received will be the subject of an
               acknowledgment of receipt and a request
               for clarification no later than 5 days after
                the sending of the form and the supporting
               documents requested.</p>
            <p>Please note that a proof of your identity will
               be asked to you in order to ensure the
               security and to respond properly to your request.</p>
            <v-select
            v-model="gdpr.Type"
            :items="types"
            :rules="noEmpty"
            label="I want to"
            required>
            </v-select>
            <v-text-field
            v-model="gdpr.Surname"
            :rules="noEmpty"
            label="Surname"
            single-line hide-details
            required>
            </v-text-field>
            <v-text-field
            v-model="gdpr.Name"
            :rules="noEmpty"
            label="Name"
            single-line hide-details
            required>
            </v-text-field>
            <v-text-field
            v-model="gdpr.Email"
            :rules="emailRules"
            label="Email"
            single-line hide-details
            required
            autocomplete>
            </v-text-field>
            <div>
              <br/>
              <p>
                <strong>GEODIS has always considered data privacy as one of its priorities.
                 We implement strong security solutions in compliance with the GDPR
                  provisions. Taking into account the obligations set by this legislation,
                  we seek the following express consents from you:
                </strong>
              </p>
              <p>You authorize GEODIS to collect and process your personal data.
                 Such data are necessary to provide you information and marketing offers.
                  You can, at any time, (i) withdraw permission and (ii) get access to your
                   personal data stored and process by GEODIS. In GEODIS, your data privacy
                    rights are protected by our Data Protection Officer
                     (<a href="mailto:dpo@geodis.com">dpo@geodis.com</a>).
                   The retention period of your personal data is limited to 3 years,
                    after which, your data will be deleted. Your data will be stored
                     within the European Union borders and Switzerland and won’t be
                      used for any automated processing, including profiling.</p>
              <p>Security measures required by the legislation are being implemented.</p>
              <p>You have read and agree with GEODIS
                <a href="https://geodis.com/en/privacy" target="_blank">Privacy Policy</a>.
                </p>
              <p>You’re aware of your rights as a Data Subject. You can contact at any
                 time GEODIS claiming for your rights.</p>
            </div>
            <v-checkbox
            v-model="Agree"
            :rules="[v => !!v || 'You must agree to continue!']"
            label="I AGREE"
            required
            ></v-checkbox>
            <span v-if="Sended" style="color: green; font-weight: bold;">
               Your request has been successfuly sent
              </span>
              <br/>
            <v-btn type="submit" color="primary" :disabled="!valid"
            @click.prevent="SendGDPR">Apply</v-btn>
          </v-form>
         </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="geodis-logo">
    </div>
    <!-- <div class="" style="width:100%; color: #3200E6" align="center">
      <a href="http://www.geodis.com" target="_blank">GEODIS</a> - All rights reserved -
      <a href="https://geodis.sharepoint.com/sites/sco-sco-dev-wep-portal/SitePages/About/Legal.aspx" target="_blank">
        Legal Information</a>
    </div> -->
  </v-container>
</template>
<style scoped>
html {
    font-size: inherit;
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-family: sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
}
body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    background-color: #fff;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
a {text-decoration: none;}
.workspace-item {
    background-color: #fff;
    width: 190px;
    height: 180px;
    margin: 0 25px 25px 0;
    padding: 5px 15px 15px 15px;
    transition: box-shadow 300ms ease;
}
p {text-align: justify}
.title {
    color: #949494;
    font-size: 0.9em !important;
    font-weight: normal !important;
    font-family: 'AvenirLTStd-Book' !important;
    font: 75%/1.5 Arial,Helvetica,sans-serif;
    margin: 0;
    line-height: 1.5em;
    text-decoration: none;
}
.logo {
    width: 120px;
    height: 120px;
    z-index: 0;
}
</style>
<script>
import { mapState } from 'vuex';
import { GDPR } from '@/api';

export default {
  name: 'GDPR',
  data() {
    return {
      types: ['Ask for personal data processing limitation', 'Access to my personal data', 'Rectify my personal data', 'Ask to be forgotten', 'Ask for personal data portability', 'Modify a consent', 'Make a claim on my personal data'],
      gdpr: {
        Type: '',
        Surname: '',
        Name: '',
        Email: '',
        Address: '',
      },
      Agree: 0,
      Sended: false,
      dialogs: { },
      loading: true,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'],
      noEmpty: [
        v => !!v || 'This value is required'],
    };
  },
  computed: {
    ...mapState({
      admin: 'IsAdmin',
    }),
    method() {
      return 'create';
    },
  },
  methods: {
    async SendGDPR() {
      if (this.$refs.GDPRForm.validate()) {
        this.$store.commit('START_LOADING');
        try {
          if (this.valid) {
            if (this.Agree) {
              const { data: gdpr } = await GDPR[this.method](this.gdpr);
              const { data: sended } = await GDPR.send(this.gdpr);
              console.debug(gdpr);
              console.debug(sended);
              if (gdpr) {
                this.Sended = true;
                this.valid = false;
              }
            } else {
              this.valid = false;
              this.Sended = false;
            }
          }
        } catch (err) {
          this.errors = err;
          console.debug(err);
        }
        this.$store.commit('END_LOADING');
      }
    },
  },
  mounted() {
    console.debug('GDPR');
  },
};
</script>
